import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
export default (function (_ref, inject) {
  var store = _ref.app.store;
  var isPresent = function isPresent(tooltip) {
    var _store$$auth$user, _store$$auth$user$too;
    return (store === null || store === void 0 ? void 0 : store.$auth.loggedIn) && ((_store$$auth$user = store.$auth.user) === null || _store$$auth$user === void 0 ? void 0 : (_store$$auth$user$too = _store$$auth$user.tooltips) === null || _store$$auth$user$too === void 0 ? void 0 : _store$$auth$user$too.includes(tooltip));
  };
  var close = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tooltip) {
      var _store$$auth$user2;
      var user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(isPresent(tooltip) || !(store !== null && store !== void 0 && (_store$$auth$user2 = store.$auth.user) !== null && _store$$auth$user2 !== void 0 && _store$$auth$user2.tooltips))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            user = _objectSpread(_objectSpread({}, store.$auth.user), {}, {
              tooltips: [].concat(_toConsumableArray(store.$auth.user.tooltips), [tooltip])
            });
            store.$auth.$storage.setState('user', user);
            _context.next = 6;
            return store.$api.$get("/profile/tooltips/complete.json?task=".concat(tooltip));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function close(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  inject('tooltip', {
    close: close,
    isPresent: isPresent
  });
});